<template lang="html">
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Edit User</h4>
                    </div>
                    <vs-button
                        color="primary"
                        class="mb-4 mr-1 btn md:mb-0"
                        @click="submitForm"
                        v-show="editMode"
                    >Save</vs-button>
                    <vs-button
                        color="primary"
                        class="mb-4 mr-1 btn md:mb-0"
                        @click="editMode = true"
                        v-show="!editMode"
                        icon="edit"
                    >Edit</vs-button>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Username*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.username" :disabled="!editMode"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Email*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.email" :disabled="!editMode"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Password*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.password" type="password" :disabled="!editMode"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                User Group*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.user_group_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, usergroup)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in usergroup.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                User Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.user_type"
                                    width="100%"
                                    autocomplete
                                    :disabled="!editMode"
                                >
                                    <vs-select-item value="Regular" text="Regular"/>
                                    <vs-select-item value="Client" text="Client"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Status*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.status"
                                    width="100%"
                                    autocomplete
                                    :disabled="!editMode"
                                >
                                    <vs-select-item value="1" text="Active"/>
                                    <vs-select-item value="0" text="Inactive"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Vehicle
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.vehicle_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="!editMode"
                                    @input-change="searchDropdown($event, vehicle)"
                                >
                                    <vs-select-item v-for="(item, index) in vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">User Access</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.client_access"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchMultiple($event, client)"
                                    multiple
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Warehouse Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.warehouse_access"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchMultiple($event, warehouse)"
                                    multiple
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">User Defaults</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client Default
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Origin ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.origin_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Destination ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.destination_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Supplier ID
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.supplier_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Warehouse Default
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, warehouse)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Inbound Type
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.inbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound Type
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.outbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Base UoM
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.base_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, uom)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Part UoM
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.part_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, uom)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Unit Weight
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.unit_weight_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_weight)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in unit_weight.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Section
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.section_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, section)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Currency
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.currency_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, currency)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in currency.data" :key="index" :value="item.id" :text="item.currency_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Stock Type
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, stock_type)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row" >
                            <div class="w-1/3 vx-col">
                                Product Category
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.product_categories_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, product_category)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item
                                    v-for="(item, index) in product_category.data"
                                    :key="index" :value="item.id" :text="item.name" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Unit Volume
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.unit_volume_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_volume)"
                                    :disabled="!editMode"
                                >
                                    <vs-select-item class="" v-for="(item, index) in unit_volume.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>

                <vs-divider border-style="solid">Auto Generate Report</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Send Report By Email
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.report_by_email"
                                    width="100%"
                                    autocomplete
                                    :disabled="!editMode"
                                >
                                    <vs-select-item value="1" text="Yes"/>
                                    <vs-select-item value="0" text="No"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Password Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.report_password" type="password" :disabled="!editMode"/>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import { AgGridVue } from "ag-grid-vue";

	export default {
        // updated(){
        //     console.log(this.form.id + ' tes');
        // },
		components:{
            vSelect,
            AgGridVue
		},
		data(){
			return {
                isLoading: false,
                editMode: false,
                show: true,
                user: {
                    username: null,
                    email: null,
                    password: null,
                    report_password: null,
                    user_group_id: null,
                    vehicle_id: null,
                    client_id: null,
                    user_type: null,
                    status: null,
                    report_by_email: null
                },
                defaults: {
                    client_access: [],
                    warehouse_access: [],
                    client_id: null,
                    warehouse_id: null,
                    origin_id: null,
                    destination_id: null,
                    supplier_id: null,
                    inbound_type_id: null,
                    outbound_type_id: null,
                    section_id: null,
                    base_uom_id: null,
                    part_uom_id: null,
                    unit_weight_id: null,
                    unit_volume_id: null,
                    currency_id: null,
                    stock_type_id: null,
                    product_categories_id: null
                },
                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                usergroup: {
                    data: [],
                    loading: false,
                    endpoint: 'rolemanagement/usergroup',
                    objectKey: 'name'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                currency: {
                    data: [],
                    loading: false,
                    endpoint: 'master/currency',
                    objectKey: 'currency_code'
                },
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'name'
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
                uom: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uom',
                    objectKey: 'name'
                },
                unit_weight: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uow',
                    objectKey: 'name'
                },
                section: {
                    data: [],
                    loading: false,
                    endpoint: 'master/sections',
                    objectKey: 'section_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
                product_category: {
                    data: [],
                    loading: false,
                    endpoint: 'master/productcategories',
                    objectKey: 'name'
                },
                unit_volume: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uov',
                    objectKey: 'name'
                },
                vehicle: {
                    data: [],
                    loading: false,
                    endpoint: 'master/vehicle',
                    objectKey: 'vehicle_code'
                },
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true
                this.$http.get('/rolemanagement/users/' + this.$route.params.id)
                .then(resp => {

                    let clients = [];
                    let customers = [];
                    let order_types = [];
                    let uoms = [];
                    let warehouses = [];
                    let vehicles = [];

                    let userconfig = resp.data.userconfig
                    let user = resp.data.user

                    user.client_access.map(i => {
                        clients.push(i)
                    })

                    user.warehouse_access.map(i => {
                        warehouses.push(i)
                    })

                    clients.push(user.clients)
                    clients.push(userconfig.clients)
                    customers.push(userconfig.destination)
                    customers.push(userconfig.origin)
                    customers.push(userconfig.supplier)
                    vehicles.push(user.vehicles)
                    order_types.push(userconfig.inbound_type)
                    order_types.push(userconfig.outbound_type)
                    uoms.push(userconfig.base_uom)
                    uoms.push(userconfig.part_uom)
                    warehouses.push(userconfig.warehouses)

                    console.log(vehicles);

                    this.vehicle.data = this.$_.uniqBy(this.$_.compact(vehicles), i => i.id);
                    this.client.data = this.$_.uniqBy(this.$_.compact(clients), i => i.id);
                    this.customer.data = this.$_.uniqBy(this.$_.compact(customers), i => i.id);
                    this.order_type.data = this.$_.uniqBy(this.$_.compact(order_types), i => i.id);
                    this.uom.data = this.$_.uniqBy(this.$_.compact(uoms), i => i.id);
                    this.warehouse.data = this.$_.uniqBy(this.$_.compact(warehouses), i => i.id);
                    this.section.data = this.$_.uniqBy(this.$_.compact([userconfig.section]), i => i.id);
                    this.unit_weight.data = this.$_.uniqBy(this.$_.compact([userconfig.unit_weight]), i => i.id);
                    this.currency.data = this.$_.uniqBy(this.$_.compact([userconfig.currency]), i => i.id);
                    this.stock_type.data = this.$_.uniqBy(this.$_.compact([userconfig.stock_type]), i => i.id);
                    this.product_category.data = this.$_.uniqBy(this.$_.compact([userconfig.product_categories]), i => i.id);
                    this.unit_volume.data = this.$_.uniqBy(this.$_.compact([userconfig.unit_volume]), i => i.id);
                    this.usergroup.data = this.$_.uniqBy(this.$_.compact([user.user_group]), i => i.id);

                    this.client.data.unshift({
                        id: null,
                        client_code: 'None'
                    })

                    this.vehicle.data.unshift({
                        id: null,
                        vehicle_code: 'None'
                    })

                    this.customer.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.order_type.data.unshift({
                        id: null,
                        order_type: 'None'
                    })

                    this.uom.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.warehouse.data.unshift({
                        id: null,
                        warehouses_code: 'None'
                    })

                    this.section.data.unshift({
                        id: null,
                        section_code: 'None'
                    })

                    this.unit_weight.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.currency.data.unshift({
                        id: null,
                        currency_code: 'None'
                    })

                    this.stock_type.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.product_category.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.unit_volume.data.unshift({
                        id: null,
                        name: 'None'
                    })

                    this.user.username = user.username
                    this.user.email = user.email
                    this.user.password = user.password
                    this.user.user_type = user.user_type
                    this.user.status = user.status
                    this.user.user_group_id = user.user_group.id
                    this.user.client_id = user.client_id
                    this.user.vehicle_id = user.vehicle_id
                    this.user.report_by_email = user.report_by_email
                    //this.user.report_password = user.report_password

                    this.defaults.client_access = user.client_access.map(i => i.id);
                    this.defaults.warehouse_access = user.warehouse_access.map(i => i.id);
                    this.defaults.client_id = userconfig.client_id
                    this.defaults.origin_id = userconfig.origin_id
                    this.defaults.destination_id = userconfig.destination_id
                    this.defaults.supplier_id = userconfig.supplier_id
                    this.defaults.warehouse_id = userconfig.warehouse_id
                    this.defaults.inbound_type_id = userconfig.inbound_type_id
                    this.defaults.outbound_type_id = userconfig.outbound_type_id
                    this.defaults.base_uom_id = userconfig.base_uom_id
                    this.defaults.part_uom_id = userconfig.part_uom_id
                    this.defaults.unit_weight_id = userconfig.unit_weight_id
                    this.defaults.unit_volume_id = userconfig.unit_volume_id
                    this.defaults.currency_id = userconfig.currency_id
                    this.defaults.stock_type_id = userconfig.stock_type_id
                    this.defaults.product_categories_id = userconfig.product_categories_id
                    this.defaults.section_id = userconfig.section_id

                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false
                })
            },
            submitForm() {
                this.isLoading = true;
                this.$http.put("rolemanagement/users/" + this.$route.params.id + "/update", {
                    user: this.user,
                    defaults: this.defaults
                })
                .then(res => {
                this.isLoading = false;

                this.$router.push({
                    name: "user-view",
                    params: {
                        id: this.$route.params.id
                    }
                });

                this.editMode = false;

                const message = res.data.message ? res.data.message : 'Success.'
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                })
                .catch(error => this.handleError(error));
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else {
                    this.$router.go(-1)
                }
            },
            searchMultiple(event, parent) {
                const arr = event.target.value.split(',')
                const last = this.$_.last(arr)

                const query = {
                    [parent.objectKey]: last
                };

                this.$http.post(parent.endpoint, query).then(res => {
                    parent.loading = false;
                    res.data.data.map(d => {
                        if (parent.data.findIndex(p => p.id === d.id) === -1) {
                            parent.data.push(d);
                        }
                    });
                });
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>

<style>

</style>
